const LegalHtmlPage = ({ src, title }: { src: string; title: string }) => {
	return <iframe src={src} title={title} style={{ width: '100%', minHeight: '100vh' }} />;
};

export const TermsOfServiceKrPage = () => {
	return <LegalHtmlPage src="html/terms-of-service-kr.html" title="이용약관 동의" />;
};

export const TermsOfServiceEnPage = () => {
	return <LegalHtmlPage src="html/terms-of-service-en.html" title="Terms of service" />;
};

export const TermsOfServiceJpPage = () => {
	return <LegalHtmlPage src="html/terms-of-service-jp.html" title="利用規約" />;
};

export const TermsOfServiceEsPage = () => {
	return <LegalHtmlPage src="html/terms-of-service-es.html" title="Términos del servicio" />;
};

export const TermsOfServiceFrPage = () => {
	return <LegalHtmlPage src="html/terms-of-service-fr.html" title="Conditions d'utilisation" />;
};

export const TermsOfServiceRuPage = () => {
	return <LegalHtmlPage src="html/terms-of-service-ru.html" title="Условия использования" />;
};
